<div
  class="tw-flex tw-mb-2 tw-justify-between tw-items-center"
  [ngClass]="{ 'tw-h-12': title, 'tw-h-6': !title }"
>
  <div class="tw-header-lg">{{ title }}</div>
  <button
    type="button"
    [tabIndex]="-1"
    (click)="onClose($event)"
    class="p-dialog-header-icon p-link"
  >
    <span class="p-dialog-header-close-icon pi pi-times"></span>
  </button>
</div>
